import { TWhiteLabel } from '../white-label.model';
import { getDefaultPanelColors } from './get-default-panel-colors';
import { isChosenColor } from './is-chosen-color';

export type TNavItemHoverColors = {
  font: string;
  border: string;
  activeBackground: string;
  icon: string;
};
const CHOSEN_HOVER_ICON_COLOR = 'var(--fg-inverted)';

export function resolveNavItemHoverColors(whiteLabelData: TWhiteLabel): TNavItemHoverColors {
  const defaultPanelColors = getDefaultPanelColors();

  const chosePanelFont = isChosenColor(whiteLabelData.panelFont, defaultPanelColors.panelFont);
  const chosePanelFontHighlight = isChosenColor(
    whiteLabelData.panelFontHighlight,
    defaultPanelColors.panelFontHighlight,
  );

  return {
    font: chosePanelFont ? whiteLabelData.panelFont : whiteLabelData.panelTextHover,
    border: chosePanelFont ? whiteLabelData.panelFont : '',
    activeBackground: chosePanelFontHighlight ? whiteLabelData.panelFontHighlight : '',
    icon: chosePanelFont ? CHOSEN_HOVER_ICON_COLOR : '',
  };
}
